// angular
import { Title } from '@angular/platform-browser';
import { Component, inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterOutlet,
} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';
// services
import { InitService } from '@shared/services/init.service';
import { LayoutService } from './layout/shared/services/layout.service';
import { environment } from '@environments/environment';

declare const gtag: Function;

@Component({
  selector: 'pwj-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'website-wejoiner';

  // dependencies
  private readonly _initService = inject(InitService);
  private readonly _router = inject(Router);
  private readonly _activatedRoute = inject(ActivatedRoute);
  private readonly _titleService = inject(Title);
  private readonly _translateService = inject(TranslateService);
  private readonly _layoutService = inject(LayoutService);
  private readonly _platformId = inject(PLATFORM_ID);

  constructor() {
    this._initService.init();

    this._router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          let route = this._activatedRoute;
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        switchMap(route => route.data),
        map(data => data['titleKey'])
      )
      .subscribe(titleKey => {
        if (titleKey) {
          this._translateService.get(titleKey).subscribe(translatedTitle => {
            this._titleService.setTitle(translatedTitle);
            this._layoutService.setTitleKey(translatedTitle);
          });
        }
      });

    // this._router.events.forEach(item => {
    //   if (
    //     item instanceof NavigationEnd &&
    //     isPlatformBrowser(this._platformId)
    //   ) {
    //     gtag('config', environment.googleAnalytics, {
    //       page_path: item.urlAfterRedirects,
    //     });
    //   }
    // });
  }
}
